import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { GridParams } from 'common/models/utility-models/list-utility.model';
import { DataModel, MetaModel, WidgetModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { ViewTrainersGridDataService } from 'common/services/data-services/admin/trainer/trainer-view/view-trainers-data.service';
import { SmMetaModel } from 'common/models/utility-models/meta-model';
import { StudentTrainerAssignmentGridMetaModel } from 'common/models/page-models/Student Trainer/student-trainer-assignment-grid-meta-model';
import { StudentTrainerAssignmentListingModel } from 'common/models/page-models/Student Trainer/student-trainer-assignment-grid.model';
import { TrainersModel } from 'common/models/page-models/Trainers Model/trainers-data.model';
import { StudentTrainerAssignmentGridDataService } from 'common/services/data-services/Student Trainer/student-trainer-assignment-data.service';
import { AssignmentModel } from 'common/models/page-models/Assignments Model/assignment-data.model';





@Injectable({
  providedIn: 'root'
})
export class StudentTrainerAssignmentGridWidgetService extends GridWidgetService<TrainersModel, StudentTrainerAssignmentListingModel> {
  constructor(protected override ds: StudentTrainerAssignmentGridDataService, protected ss: SystemService) {
    super(ds);
  }

  createQueryParams(queryParam): GridParams {
    for (const key in queryParam) {
      this.queryparm[key] = queryParam[key];
    }
    return this.queryparm;
  }

  getMetaModel(): MetaModel {
    const meta = new StudentTrainerAssignmentGridMetaModel().getMetaModel();
    return meta;
  }

  Save(body, url) {
    this.ds.postLoginData(body, url).then((response) => {
      // console.log("RESPONSE",response);
      
      if (response.status === 'Success') {
        this.ss.showSuccess(response.msg);
      }

    });
  }




}